import { FunctionComponent, ReactNode } from 'react'
import contextStandardTeaser from '@contexts/standardTeaser'
import { ArticleType } from './types'
import { TeaserFlexValueDesktop } from '../types'

interface StandardTeaserLayoutContextProvider {
  teaserFlex: TeaserFlexValueDesktop
  accentColor: string
  isVideoOnly: boolean
  hasVideoOnlyStyle: boolean
  isInMegaModule: boolean
  hasExtraLargeTabletStyle: boolean
  hasMiniDesktopStyle: boolean
  articleType: ArticleType
  isPromo: boolean
  children?: ReactNode
}

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StandardTeaserLayoutContextProvider: FunctionComponent<
  StandardTeaserLayoutContextProvider
> = ({
  teaserFlex,
  accentColor,
  isVideoOnly,
  hasVideoOnlyStyle,
  isInMegaModule,
  articleType,
  hasExtraLargeTabletStyle,
  hasMiniDesktopStyle,
  isPromo,
  children,
}) => (
  <StandardTeaserLayoutContext.Provider
    value={{
      teaserFlex,
      accentColor,
      isVideoOnly,
      hasVideoOnlyStyle,
      articleType,
      isInMegaModule,
      hasExtraLargeTabletStyle,
      hasMiniDesktopStyle,
      isPromo,
    }}>
    {children}
  </StandardTeaserLayoutContext.Provider>
)

export default StandardTeaserLayoutContextProvider
